import request from '@/services/interceptor.js'


// Ordini
export const get_riepilogoMensile = par => {
  return request({
    url: '/api/orders/monthly/' + par,
    method: 'get'
  })
};
export const get_statoOrdini = (par) => {
  return request({
    url: '/api/orders/production/' + par,
    method: 'get'
  })
};
export const get_dettaglioOrdini = (par) => {
  return request({
    url: '/api/orders/production/detail/' + par,
    method: 'get',
    noLoadingBar: true
  })
};


export const get_confemeOrdini = (par) => {
  return request({
    url: '/api/orders/conferme/' + par,
    method: 'get',
  })
};


export const save_confermeOrdini = (par) => {
  return request({
    url: '/api/orders/conferme',
    method: 'post',
    data: par,
    noLoadingBar: true
  })
};

export const get_pdfOrdini = (par) => {
  return request({
    url: '/api/orders/pdf/' + par,
    method: 'get',
    responseType: 'blob',
  })
};

export const get_riepilogoGiorno = (data) => {
  return request({
    url: "api/orders/daily",
    method: 'post',
    data: data
  })
}

//#region NON CONFORMITA
export const get_elencoResi = (par) => {
  return request({
    url: '/api/orders/resi/' + par,
    method: 'get',
  })
};

export const get_elencoOmaggi = (par) => {
  return request({
    url: '/api/orders/omaggi/' + par,
    method: 'get',
  })
};

export const set_ordineVisionato = (data) => {
  return request({
    url: '/api/orders/resi/visionato',
    method: 'post',
    data: data
  })
}
//#endregion